import { Component, OnInit } from '@angular/core';
import { MatchMedia } from '@angular/flex-layout/core/typings/match-media';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

// Models
import { PacketDetails } from '../../shared/configuration.model';

// Services
import { ConfigurationService } from '../../shared/configuration.service';
import { LocalStorage } from '../../shared/localstorage.service';

@Component({
  selector: 'app-reports',
  templateUrl: './packetDashboard.component.html',
  styleUrls: ['./packetDashboard.component.scss']
})
export class PacketDashboardComponent implements OnInit {
    public packets: PacketDetails[];
    public packetStatsByPacketId: {[key:string]: packetStats} = {};

    private getPackagesSubscription: Subscription;
    private getUserPacketStatsSubscription: Subscription;

    constructor(
        private _router: Router,
        private localStorage: LocalStorage,
        private ConfiugationService: ConfigurationService
    ) {}

    ngOnInit() {
        this.getPackagesSubscription = this.ConfiugationService.getPackages(this.localStorage.getItem('currentState')).subscribe(packets => {
            this.packets = packets;

            packets.forEach(packet => {
                this.getUserPacketStatsSubscription = this.ConfiugationService.getUserPacketStats(packet.ID, this.localStorage.getItem('currentState')).subscribe(response => {
                    this.packetStatsByPacketId[packet.ID] = response.json();
                })
            })
        });
    }

    ngOnDestroy() {
        this.getPackagesSubscription.unsubscribe();
        this.getUserPacketStatsSubscription.unsubscribe();
    }

    customizeLabel(arg) {
        return `${arg.value} ${arg.value === 1 ? 'user' : 'users'} at ${arg.argument.toFixed(arg.argument % 1 ? 2 : 0) + '%'} (${arg.percentText})`;
    }

    sortLegendItems(items) {
        return items.sort((a, b) => a.text < b.text ? -1 : 1 );
    }

    customizeLegendText(point) {
        return point.pointName.toFixed(point.pointName % 1 ? 2 : 0) + '%'
    }

    onPointClick({event, packetId}) {
        this._router.navigate(['/report/packet/', packetId, {filterCompletion: event.target.data.PacketCompletionPercentage}]);
    }
}

class packetStats {
    PacketCompletionPercentage: number;
    userCount: number;
}
